<template>
<v-container class="container input-text-size">
  <!-- <loader v-if="loading"/> -->
  <percetageProgressBar
  :value="totalImported" :totalRecords="totalRecords" :loading="loading" />
  <v-row class="row" dense>
      <div class="heading">
      <p>Tax Roll Work File</p>
    </div>
    </v-row>
  <v-row class="row" dense>
      <v-subheader class="label-left input-text-size"> Tax Year - From</v-subheader>
      <v-col cols="2">
      <CommonDropDowns :isItTaxYearWithoutAllYears=true
        @change="dataFromCommonDropDowns" :criteriaState="criteriaState"
        :addTaxYearEmpty=true  taxYearNameOverride="taxYearFrom"
        :taxYearValue="trWorkFileFields.taxYearFrom" />
    </v-col>
    <v-subheader class="label-left input-text-size">To</v-subheader>
    <v-col cols="2">
      <CommonDropDowns :isItTaxYearWithoutAllYears=true :addTaxYearEmpty=true
        @change="dataFromCommonDropDowns" :criteriaState="criteriaState"
        taxYearNameOverride="taxYearTo" :taxYearValue="trWorkFileFields.taxYearTo"/>
    </v-col>
    <div class="wrapper">
    <v-subheader class="label-left input-text-size">Load Profile</v-subheader>
    <v-col cols="7">
      <v-combobox
      class="input-text-size mt-n2"
      dense
      :items="profiles"
      outlined
      v-model="trWorkFileFields.profileName"
      @input.native="trWorkFileFields.profileName=$event.srcElement.value"
      @change="searchByCriteria"
      @blur="checkForEmptyProfileName"
    >
  </v-combobox>
  </v-col>
  <v-col cols="2">
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary"
      small @click="upsertTrWorkFileRecords"
      :disabled="!trWorkFileFields.profileName || !!excMtgCodeRangeError"
      >
      Save
     </v-btn>
    </template>
    <span>Save Profile with current setting</span>
    </v-tooltip>
  </v-col>
   <v-col cols="1">
    <v-btn small color="primary" @click="deleteProfile"
    :disabled="!trWorkFileFields.profileName || checkForEmptyObject(trWorkFileFields)
    || checkForNotSavedProfile()">
    Delete</v-btn>
  </v-col>
  </div>
  </v-row>
  <v-row class="row" dense>
      <v-subheader class="label-left input-text-size mt-8">Tax Types to include</v-subheader>
      <v-col cols="2">
            <MultiItemSelect
          class="input-text-size"
            label="By Tax type"
            item-text="description"
            item-value="name"
            :item-list="TaxTypeEnum"
            :items="trWorkFileFields.taxType || []"
            @selected-items="selectedTaxTypes"
          />
    </v-col>
  </v-row>
  <div class="box-ctnr">
  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size">Tax Status: </v-subheader>
      <v-checkbox hide-details label="Any Tax Due(Original statement)"
      v-model="trWorkFileFields.anyTaxDue"></v-checkbox>
    <!-- <v-subheader class="label-left">Any Tax Due(Original statement)  </v-subheader> -->
     <v-checkbox hide-details label="No Tax (Exempt)"
     v-model="trWorkFileFields.noTax"></v-checkbox>
  </v-row>
</div>
<div class="box-ctnr">
  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size">Payment Status: </v-subheader>
      <v-checkbox
      hide-details
      label="Any Tax Still Due"
      class="mb-2 "
      v-model="trWorkFileFields.anyTaxStillDue">
      </v-checkbox>
     <v-checkbox
     hide-details
     label="No Payments"
     v-model="trWorkFileFields.noPayments">
     </v-checkbox>
     <v-checkbox
     hide-details
     label="Half/Partial Payment"
     v-model="trWorkFileFields.halfOrPartialPayment">
     </v-checkbox>
     <v-checkbox
     hide-details
     label="Paid in Full"
     v-model="trWorkFileFields.paidInFull"
     ></v-checkbox>

  </v-row>
</div>
<div class="box-ctnr">
  <div>
     <v-row class="row" dense>
    <v-subheader class="label-left input-text-size">Include: </v-subheader>
  </v-row>
</div>
<div>
    <v-row class="row" dense>
      <v-checkbox
      hide-details
      label="Anything with a Mtg Code"
      v-model="trWorkFileFields.incAnythingWithMtgCode"
      :readonly="trWorkFileFields.excAnythingWithMtgCode" :tabindex="trWorkFileFields.excAnythingWithMtgCode ? -1 : 0">
      </v-checkbox>
    <v-subheader class="label-left input-text-size">From Mtg Code</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
       outlined
       small
       hide-details
        dense
        v-model="trWorkFileFields.incFromMtgCode"
        :readonly="trWorkFileFields.incAnythingWithMtgCode" :tabindex="trWorkFileFields.incAnythingWithMtgCode ? -1 : 0"
      ></v-text-field>
    </v-col>
    <v-subheader class="label-left input-text-size">To Mtg Code</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      v-model="trWorkFileFields.incToMtgCode"
      :readonly="trWorkFileFields.incAnythingWithMtgCode" :tabindex="trWorkFileFields.incAnythingWithMtgCode ? -1 : 0"
      ></v-text-field>
    </v-col>
  </v-row>

  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size mt-8">Only these Status Codes</v-subheader>
    <v-col cols="3">
      <MultiItemSelect
      v-model="trWorkFileFields.incOnlyTheseStatusCodes"
      label="Status"
      :items="incStatus"
      :item-list="taxStatusCodes"
      item-text="name"
      item-value="value"
      single-line
      @selected-items="incselectedStausCodes"
      multiple
      >
      </MultiItemSelect>
    </v-col>
  </v-row>
  <v-row class="row" dense>
      <v-checkbox
      hide-details
      label="Anything with Certificate Number"
      :readonly="trWorkFileFields.excAnythingWithCertificateNumber" :tabindex="trWorkFileFields.excAnythingWithCertificateNumber ? -1 : 0"
      v-model="trWorkFileFields.incAnythingWithCertificateNumber"></v-checkbox>
    <v-subheader class="label-left input-text-size">From Cert#</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      type="number"
      :readonly="trWorkFileFields.incAnythingWithCertificateNumber" :tabindex="trWorkFileFields.incAnythingWithCertificateNumber ? -1 : 0"
      v-model.number="trWorkFileFields.incFromCertificateNumber"
      ></v-text-field>
    </v-col>
    <v-subheader class="label-left input-text-size">To Cert#</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      type="number"
      :readonly="trWorkFileFields.incAnythingWithCertificateNumber" :tabindex="trWorkFileFields.incAnythingWithCertificateNumber ? -1 : 0"
      v-model.number="trWorkFileFields.incToCertificateNumber"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size mt-8">Tax Districts : </v-subheader>
    <v-col cols="4">
    <MultiItemSelect
      v-model="trWorkFileFields.incTaxDistricts"
      label="Districts"
      :items="taxDistricts"
      :item-list="taxDistrictsList"
      item-text="taxDistrictCodeAndName"
      item-value="districtCode"
      single-line
      @selected-items="incselectedTaxDistricts"
      multiple
      />
    </v-col>
    <v-subheader class="label-left input-text-size mt-8">Tax Amount Greater Than</v-subheader>
    <v-col cols="2">
      <v-text-field outlined small hide-details dense class="mt-8"
      v-model.number="trWorkFileFields.incTaxAmountGreaterThan" type="number" />
    </v-col>
   </v-row>
    <!-- <v-row class="row" dense>
      <v-checkbox
      hide-details
      label="Anything with Email Address"
      :readonly="trWorkFileFields.excAnythingWithEmailAddress" :tabindex="trWorkFileFields.excAnythingWithEmailAddress ? -1 : 0"
      v-model="trWorkFileFields.incAnythingWithEmailAddress">
      </v-checkbox>
      <v-checkbox
      hide-details
      label="Assessor changes"
      v-model="trWorkFileFields.incAssessorChanges">
      </v-checkbox>
    <v-subheader class="label-left input-text-size">From Date</v-subheader>
    <v-col cols="2">
      <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6" outlined
                    :isRequired="false" v-model="trWorkFileFields.incFromDate"
                    :isToggle="false"/>
    </v-col>
    <v-subheader class="label-left input-text-size">To Date</v-subheader>
    <v-col cols="2">
      <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6" outlined
                    :isRequired="false" v-model="trWorkFileFields.incToDate"
                    :isToggle="false"/>
    </v-col>
  </v-row> -->
  <!-- <v-row dense>
      <v-checkbox
      hide-details
      label="Advertised"
      :disabled="trWorkFileFields.excAdvertised"
      v-model="trWorkFileFields.incAdvertised">
      </v-checkbox>
      <v-subheader class="label-left input-text-size">From date</v-subheader>
    <v-col cols="2">

     <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6" outlined
                    :isRequired="false"
                    v-model="trWorkFileFields.incAdvertisedFromeDate"
                    :isToggle="false" :isDisabled="trWorkFileFields.excAdvertised"/>
    </v-col>
      </v-row> -->
</div>
</div>
<div class="box-ctnr">
  <div>
  <v-row class="row" dense>
  <v-subheader class="label-left input-text-size">Exclude: </v-subheader>
</v-row>
</div>
<div>
  <v-row class="row" dense>
      <v-checkbox
      hide-details
      label="Anything with a Mtg Code"
     v-model="trWorkFileFields.excAnythingWithMtgCode"
     :readonly="trWorkFileFields.incAnythingWithMtgCode" :tabindex="trWorkFileFields.incAnythingWithMtgCode ? -1 : 0">
      </v-checkbox>
    <v-subheader class="label-left input-text-size">Exclude these Mtg Codes : </v-subheader>
    <v-col cols="6">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      v-model="trWorkFileFields.excOnlyTheseMtgCodes"
      ></v-text-field >
    </v-col>
  </v-row>
  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size">From Mtg Code</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      dense
      persistent-hint
      :hint="excMtgCodeRangeHint"
      :error-messages="excMtgCodeRangeError"
      v-model="trWorkFileFields.excFromMtgCode"
      :readonly="trWorkFileFields.excAnythingWithMtgCode" :tabindex="trWorkFileFields.excAnythingWithMtgCode ? -1 : 0"
      ></v-text-field>
    </v-col>
    <v-subheader class="label-left input-text-size">To Mtg Code</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      :error="!!excMtgCodeRangeError"
      v-model="trWorkFileFields.excToMtgCode"
      :readonly="trWorkFileFields.excAnythingWithMtgCode" :tabindex="trWorkFileFields.excAnythingWithMtgCode ? -1 : 0"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row class="row" dense>
    <v-subheader class="label-left input-text-size mt-8">Only these Status Codes : </v-subheader>
    <v-col cols="4">
    <MultiItemSelect
      v-model="trWorkFileFields.excOnlyTheseStatusCodes"
      label="Status"
      :items="status"
      :item-list="taxStatusCodes"
      item-text="name"
      item-value="value"
      single-line
      @selected-items="selectedStausCodes"
      multiple
      >
      </MultiItemSelect>

    </v-col>
     <v-checkbox
      hide-details
      class="mt-10"
      label="Anything with Email Address"
      :readonly="trWorkFileFields.incAnythingWithEmailAddress" :tabindex="trWorkFileFields.incAnythingWithEmailAddress ? -1 : 0"
      v-model="trWorkFileFields.excAnythingWithEmailAddress">
      </v-checkbox>
  </v-row>
  <v-row class="row" dense>
      <v-checkbox
      hide-details
      label="Anything with Certificate Number"
      :readonly="trWorkFileFields.incAnythingWithCertificateNumber" :tabindex="trWorkFileFields.incAnythingWithCertificateNumber ? -1 : 0"
      v-model="trWorkFileFields.excAnythingWithCertificateNumber">
      </v-checkbox>
    <v-subheader class="label-left input-text-size">From Cert#</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      type="number"
      :readonly="trWorkFileFields.excAnythingWithCertificateNumber" :tabindex="trWorkFileFields.excAnythingWithCertificateNumber ? -1 : 0"
      v-model.number="trWorkFileFields.excFromCertificateNumber"
      ></v-text-field>
    </v-col>
    <v-subheader class="label-left input-text-size">To Cert#</v-subheader>
    <v-col cols="2">
      <v-text-field
      v-uppercase=globalSettingItem.conEverythingToCaps
      outlined
      small
      hide-details
      dense
      type="number"
      :readonly="trWorkFileFields.excAnythingWithCertificateNumber" :tabindex="trWorkFileFields.excAnythingWithCertificateNumber ? -1 : 0"
      v-model.number="trWorkFileFields.excToCertificateNumber"
      ></v-text-field>
    </v-col>
  </v-row>
  <!-- <v-row dense>
     <v-checkbox
      hide-details
      label="Advertised"
      :disabled="trWorkFileFields.incAdvertised"
      v-model="trWorkFileFields.excAdvertised">
      </v-checkbox>
      <v-subheader class="label-left input-text-size">From Date</v-subheader>
    <v-col cols="2">

        <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6" outlined
                    :isRequired="false" v-model="trWorkFileFields.excAdvertisedFromDate"
                    :isToggle="false" :isDisabled="trWorkFileFields.incAdvertised"/>
     </v-col>
       </v-row> -->
</div>
</div>
<v-row class="align-left row mt-n1" dense>
    <v-subheader class="label-left input-text-size">List Name : </v-subheader>
    <v-col cols="2">
     <v-combobox
     outlined
     dense
     :items="listNames"
     v-model="listNameFields.name"
     @click="showListNameInNoProfileCase"
      @input.native="listNameFields.name=$event.srcElement.value"
     >
    </v-combobox>
    </v-col>
    <v-col cols="2" class="mt-1">
      <v-btn color="primary" small @click="upsertListNameFields"
        :disabled="!!excMtgCodeRangeError">
        Build File/List
        </v-btn>
    </v-col>
</v-row>
</v-container>
</template>

<script>
import {
  mapState, mapActions, mapMutations, mapGetters,
} from 'vuex';
// import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import { getWorkstationNumber } from '../../../util/workstation-util';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
// import loader from '../common-utils/loader.vue';
import { toIsoDate } from '../../../util/shared/tmc-global';
import { flushFocusedField } from '../../../util/shared/vue-global';
import MultiItemSelect from '../../common/base/MultiItemSelect.vue';
import percetageProgressBar from '../../common/percetageProgressBar.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

// A mortgage code range compares numerically only when it is unambiguously numeric on both
// sides; this mirrors isNumericMtgCode in the backend's browseTrWorkFile.types.js.
const isNumericMtgCode = (val) => /^\d+$/.test(String(val == null ? '' : val).trim());

export default {
  name: 'createTRWorkFile',
  mixins: [GlobalToCaps],
  data() {
    return {
      trWorkFileFields: {
        taxType: [],
      },
      listNameFields: {},
      status: [],
      incStatus: [],
      taxDistricts: [],
      wkstNumber: undefined,
      baseCrudKey: 'TRWorkFileCreate',
      loading: false,
      filterdStatusCodes: [],
      totalImported: 0,
      importInterval: null,
      totalRecords: 0,
    };
  },
  components: {
    // ClarionDateControl,
    CommonDropDowns,
    // loader,
    MultiItemSelect,
    percetageProgressBar,
  },
  created() {
    this.handleCreateTrWorkFileFields();
    // this.loadLists();
    this.wkstNumber = getWorkstationNumber();
    this.handleProfileListNames();
    this.showListNameInNoProfileCase();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.tax.trWorkFile.selectedItems,
      taxStatusCodes: (state) => state.shared.taxStatusCodesShared.taxStatusCodes,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,

    }),
    ...mapGetters('tax/trWorkFile', [
      // 'getDialog',
    ]),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    dataItems: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },
    getItemsList: {
      get() {
        return this.items('profileListNames');
      },
      set(value) {
        this.setItems(['profileListNames', value]);
      },
    },
    profiles() {
      let profileNames = [];
      if (this.dataItems !== null && this.dataItems.length > 0) {
        profileNames = this.dataItems
          .filter((profile) => profile.profileName !== null)
          .map((profile) => profile.profileName);
      }
      return profileNames.sort();
    },
    listNames() {
      let listNames = [];
      if (this.getItemsList !== null && this.getItemsList.length > 0) {
        listNames = this.getItemsList
          .filter((el) => el.name !== null)
          .map((el) => el.name);
      }
      return listNames;
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    statusCodesList() {
      const updatedItem = (this.taxStatusCodes || []).filter(
        (item) => (this.trWorkFileFields.incOnlyTheseStatusCodes || []).includes(item.value),
      );
      return updatedItem;
    },
    // A mortgage code is a free-form string and counties are inconsistent about it: most codes are
    // all digits, some contain letters, and zero-padding is per-county. So a range compares
    // numerically when both bounds are all digits and as text otherwise, and the hint says which
    // reading the operator is currently getting rather than leaving them to guess.
    excMtgCodeRangeHint() {
      const { excFromMtgCode, excToMtgCode } = this.trWorkFileFields;
      if (!excFromMtgCode && !excToMtgCode) return 'Numeric codes compare as numbers, others as text';
      return this.excMtgCodeBoundsAreNumeric
        ? 'Comparing as numbers'
        : 'Comparing as text (A-Z)';
    },
    excMtgCodeBoundsAreNumeric() {
      const { excFromMtgCode, excToMtgCode } = this.trWorkFileFields;
      return (!excFromMtgCode || isNumericMtgCode(excFromMtgCode))
        && (!excToMtgCode || isNumericMtgCode(excToMtgCode));
    },
    // from=5 to=CL has no meaningful reading either way, so block it here rather than let it
    // silently fall through to the text compare on the server.
    excMtgCodeRangeError() {
      const { excFromMtgCode, excToMtgCode } = this.trWorkFileFields;
      if (!excFromMtgCode || !excToMtgCode) return '';
      if (isNumericMtgCode(excFromMtgCode) !== isNumericMtgCode(excToMtgCode)) {
        return 'From and To must both be numeric or both be non-numeric';
      }
      return '';
    },
    taxDistrictsList() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapMutations('tax/trWorkFile', [
      'setSelectedItems',
    ]),
    ...mapActions('tax/trWorkFile', [
      'loadTRWorkFileRecords',
      'upsertTaxRollFileTransaction',
      'deleteTrWorkFileProfile',
      'loadTRselectedRecord',
      'upsertTRWorkFileBrowseList',
      'loadProfileList',
      'loadBrowseTrBulkWriteStatus',
    ]),
    ...mapMutations('shared/taxStatusCodesShared', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async selectedStausCodes(val) {
      this.status = val;
      this.trWorkFileFields.excOnlyTheseStatusCodes = val;
    },
    async incselectedStausCodes(val) {
      this.incStatus = val;
      this.trWorkFileFields.incOnlyTheseStatusCodes = val;
    },
    async incselectedTaxDistricts(val) {
      this.taxDistricts = val;
      this.trWorkFileFields.incTaxDistricts = val;
    },
    handleCreateTrWorkFileFields() {
      const criteria = {
        ...this.criteriaState,
      };
      delete criteria.taxYear;
      this.loadTRWorkFileRecords({ criteria, baseCrudKey: this.baseCrudKey });
    },
    async handleProfileListNames() {
      const criteria = {
        ...this.criteriaState,
        wkstID: Number(this.wkstNumber),
      };
      delete criteria.taxYear;
      await this.loadProfileList({ criteria, baseCrudKey: 'profileListNames' });
    },

    async upsertTrWorkFileRecords() {
      // commit anything still sitting in a focused v-combobox (it only writes its
      // typed text through when told to blur) before we read trWorkFileFields
      await flushFocusedField(this);
      let conFromDate = null;
      let conToDate = null;
      // let conExcFromDate = null;
      // let conAdvFromDate = null;
      if (this.trWorkFileFields.incFromDate) {
        conFromDate = toIsoDate(this.trWorkFileFields.incFromDate);
      }
      if (this.trWorkFileFields.incToDate) {
        conToDate = toIsoDate(this.trWorkFileFields.incToDate);
      }
      // if (this.trWorkFileFields.excAdvertisedFromDate) {
      //   conExcFromDate = toIsoDate(this.trWorkFileFields.excAdvertisedFromDate);
      // }
      // if (this.trWorkFileFields.incAdvertisedFromeDate) {
      //   conAdvFromDate = toIsoDate(this.trWorkFileFields.incAdvertisedFromeDate);
      // }
      const item = {
        ...this.trWorkFileFields,
        ...{
          incFromDate: conFromDate,
          incToDate: conToDate,
          // excAdvertisedFromDate: conExcFromDate,
          // incAdvertisedFromeDate: conAdvFromDate,
        },
        wkstID: Number(this.wkstNumber),
      };
      await this.upsertTaxRollFileTransaction(
        { baseCrudKey: this.baseCrudKey, item },
      ).then(() => {
        const value = this.trWorkFileFields.profileName;
        this.searchByCriteria(value);
      });
    },
    async upsertListNameFields() {
      // commit anything still sitting in a focused v-combobox (it only writes its
      // typed text through when told to blur) before we read listNameFields
      await flushFocusedField(this);
      const item = {
        name: this.listNameFields.name,
        ...this.trWorkFileFields,
        wkstID: Number(this.wkstNumber),
      };
      this.loading = true;
      this.startImportProgressPolling();
      await this.upsertTRWorkFileBrowseList(
        { baseCrudKey: 'browseListNames', item },
      );
      const criteriaProfileList = {
        name: this.criteriaState.name,
        wkstID: Number(this.wkstNumber),
      };
      this.loadProfileList({ criteria: criteriaProfileList, baseCrudKey: 'profileListNames' });
      this.loading = false;
      const criteria = {
        name: this.listNameFields.name,
      };
      this.setCriteria(['browseListNames', criteria]);
      this.$router.push({
        path: '/tax/trworkfile/browse',
      });
    },
    dataFromCommonDropDowns(val, whichField) {
      this.trWorkFileFields[whichField] = val;
      // this.searchByCriteria();
    },
    async searchByCriteria(value) {
      this.trWorkFileFields = { ...this.trWorkFileFields, ...{ profileName: value } };
      const returnItem = await this.loadTRselectedRecord(
        { criteria: { profileName: value }, baseCrudKey: this.baseCrudKey },
      );
      if (returnItem && returnItem.length > 0) {
        const returnObj = returnItem[0];
        await this.selectedStausCodes(returnObj.excludeInfo.onlyTheseStatusCodes || []);
        await this.incselectedStausCodes(returnObj.includeInfo.onlyTheseStatusCodes || []);
        await this.incselectedTaxDistricts(returnObj.includeInfo.taxDistricts || []);
        this.trWorkFileFields = {
          _id: returnObj._id,
          profileName: returnObj.profileName,
          taxYearFrom: returnObj.taxYearFrom,
          taxYearTo: returnObj.taxYearTo,
          taxType: returnObj.taxType,
          anyTaxDue: returnObj.anyTaxDue,
          noTax: returnObj.noTax,
          anyTaxStillDue: returnObj.anyTaxStillDue,
          noPayments: returnObj.noPayments,
          halfOrPartialPayment: returnObj.halfOrPartialPayment,
          paidInFull: returnObj.paidInFull,
          incAnythingWithMtgCode: returnObj.includeInfo.anythingWithMtgCode,
          incFromMtgCode: returnObj.includeInfo.fromMtgCode,
          incToMtgCode: returnObj.includeInfo.toMtgCode,
          incOnlyTheseStatusCodes: returnObj.includeInfo.onlyTheseStatusCodes,
          incAnythingWithCertificateNumber: returnObj.includeInfo.anythingWithCertificateNumber,
          incFromCertificateNumber: returnObj.includeInfo.fromCertificateNumber,
          incTaxAmountGreaterThan: returnObj.includeInfo.incTaxAmountGreaterThan,
          incToCertificateNumber: returnObj.includeInfo.toCertificateNumber,
          incTaxDistricts: returnObj.includeInfo.taxDistricts,
          incAnythingWithEmailAddress: returnObj.includeInfo.anythingWithEmailAddress,
          // incAdvertised: returnObj.includeInfo.advertised,
          // incAssessorChanges: returnObj.includeInfo.assessorChanges,
          incFromDate: returnObj.includeInfo.fromDate,
          incToDate: returnObj.includeInfo.toDate,
          // incAdvertisedFromeDate: returnObj.includeInfo.advertisedFromdDate,
          excAnythingWithMtgCode: returnObj.excludeInfo.anythingWithMtgCode,
          excOnlyTheseMtgCodes: returnObj.excludeInfo.onlyTheseMtgCodes,
          excFromMtgCode: returnObj.excludeInfo.fromMtgCode,
          excToMtgCode: returnObj.excludeInfo.toMtgCode,
          excOnlyTheseStatusCodes: returnObj.excludeInfo.onlyTheseStatusCodes,
          excAnythingWithEmailAddress: returnObj.excludeInfo.anythingWithEmailAddress,
          excAnythingWithCertificateNumber: returnObj.excludeInfo.anythingWithCertificateNumber,
          excFromCertificateNumber: returnObj.excludeInfo.fromCertificateNumber,
          excToCertificateNumber: returnObj.excludeInfo.toCertificateNumber,
          // excAdvertised: returnObj.excludeInfo.advertised,
          // excAdvertisedFromDate: returnObj.excludeInfo.fromDate,
        };
      }
    },
    deleteProfile() {
      const item = {
        ...this.trWorkFileFields,
        wkstID: Number(this.wkstNumber),
      };
      const { baseCrudKey } = this;
      if (window.confirm('Are you sure you want to delete this profile?')) {
        this.deleteTrWorkFileProfile({ item, baseCrudKey }).then(() => {
          // this.loadProfileList();
          this.trWorkFileFields = {};
        }).catch((e) => {
          console.warn(e);
        });
      }
    },
    checkForEmptyObject(val) {
      const filteredKeys = Object.keys(val).filter((key) => key !== 'profileName');
      if (filteredKeys !== null && filteredKeys.length === 0) {
        return true;
      }
      return false;
    },
    checkForNotSavedProfile() {
      const savedProfiles = this.dataItems;
      const profileNameToCheck = this.trWorkFileFields.profileName;
      const isProfileNamePresent = savedProfiles.some(
        (profile) => profile.profileName === profileNameToCheck,
      );
      return !isProfileNamePresent;
    },
    checkForEmptyProfileName() {
      if (this.trWorkFileFields.profileName === '') {
        this.trWorkFileFields = {};
      }
    },
    selectedTaxTypes(val) {
      this.trWorkFileFields.taxType = val;
    },
    showListNameInNoProfileCase() {
      const item = {
        ...this.listNameFields,
        profileName: this.trWorkFileFields.profileName,
        wkstID: Number(this.wkstNumber),
      };
      if (!item.profileName && !this.listNameFields.name) {
        const wkstID = Number(this.wkstNumber);
        const listName = `Wkst${wkstID}List`;
        this.listNameFields.name = listName;
        if (!this.listNames.includes(listName)) {
          this.listNames.push(listName);
        }
      }
    },
    startImportProgressPolling() {
      this.importInterval = setInterval(async () => {
        const importDataStatus = await this.loadBrowseTrBulkWriteStatus();
        const {
          importedData, totalRecords, importingStatus, isThereAnError,
        } = importDataStatus;
        this.loading = importingStatus;
        this.isThereAnError = isThereAnError;
        this.totalRecords = totalRecords || 0;
        this.totalImported = importedData || 0;
        // if 'importingStatus' is false then stop polling
        if ((!importingStatus) || (importedData === null)
        || (importedData >= totalRecords)) {
          // this.loading = false;
          clearInterval(this.importInterval);
        }
      }, 2000);
    },
  },
  beforeDestroy() {
    if (this.importInterval) {
      clearInterval(this.importInterval);
    }
  },
};
</script>
<style scoped>
.row {
  margin-top: -14px;
}
.label-left {
  font-size: 1rem;
}
.container {
  border: 1px solid rgb(92, 89, 89);
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  /* padding: 0.7rem; */
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
.wrapper {
  display: flex;
  justify-content: flex-end;
  min-width: 500px;
}
.heading {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
}
.box-ctnr {
  border: 1px solid rgb(206, 197, 197);
  padding: 0.4rem;
  display: flex;
  gap: 4rem;
  /* margin-top: 0.2rem; */
  align-items: center;
  width: fit-content;
  margin: 0.2rem;
}

.align-left {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}
::v-deep.v-text-field--outlined fieldset {
top: 0px !important;
bottom: 3px !important;
}
::v-deep.v-input--selection-controls {
  margin-top: 8px;
}
</style>
